import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import env from "src/config/env";
import { getFromLocalStorage } from "src/lib/utils";

export const useDownloadInvoiceMutation = () =>
	useMutation({
		mutationFn: async (uuid) => {
			const access_token = getFromLocalStorage("access_token");

			return await axios.get(`${env.REACT_APP_API_BASE_URL}/invoices/${uuid}/download`, {
				headers: { Authorization: `Bearer ${access_token}` },
				responseType: "blob",
			});
		},
		onSuccess: (response, uuid) => {
			const blob = new Blob([response.data]);
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = url;

			const fileName = `Invoice_${uuid}.pdf`;

			link.setAttribute("download", fileName);

			document.body.appendChild(link);
			link.click();
			link.remove();

			window.URL.revokeObjectURL(url);
		},
	});
